import type { AdNetworkStatus, SubmissionResult } from '../../lib/adNetwork.hooks.js';

export interface ConnectionMetrics {
  total: number;
  connected: number;
  syncing: number;
  failed: number;
}

export function deriveConnectionMetrics(status: AdNetworkStatus): ConnectionMetrics {
  return status.submissions.reduce<ConnectionMetrics>(
    (metrics, submission) => {
      metrics.total += 1;
      if (submission.error) metrics.failed += 1;
      else if (submission.integration_id) metrics.connected += 1;
      else metrics.syncing += 1;
      return metrics;
    },
    { total: 0, connected: 0, syncing: 0, failed: 0 },
  );
}

export function getSubmissionLabel(submission: SubmissionResult | undefined): string {
  if (!submission) return 'Available';
  if (submission.error) return 'Retry';
  return submission.integration_id ? 'Connected' : 'Syncing';
}
